import { useCallback, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'

import {
  cartOffersSelector,
  fetchCartOffersAction,
  clearCartOffersAction,
} from '@monorepo/deprecated/core/features/cart'

type OptionsType = {
  enabled?: boolean
}

export function useCartOffers(options?: OptionsType) {
  const { enabled = true } = options ?? {}
  const dispatch = useDispatch()
  const { data: offers, loading } = useSelector(cartOffersSelector)

  const fetchCartOffersHandler = useCallback(
    bindActionCreators(fetchCartOffersAction, dispatch),
    []
  )

  const clearCartOffersHandler = useCallback(
    bindActionCreators(clearCartOffersAction, dispatch),
    []
  )

  useEffect(() => {
    if (enabled) {
      fetchCartOffersHandler()
    }

    return () => {
      clearCartOffersHandler()
    }
  }, [clearCartOffersHandler, enabled, fetchCartOffersHandler])

  return { offers, loading }
}
